import AutocompleteCheckbox from 'components/search/AutocompleteCheckbox';
import { useEffect, useState } from 'react';
import { FilterProps, FiltersProps, LeftFilterProps } from 'types/Filters';
import useFilters from 'views/HomePage/hooks/useFilters';
import CheckboxList from './CheckboxList';
import { NSwitch } from '@innersource-nn/novoui-react';

const LeftFilters: React.FC<FiltersProps> = ({
    filter,
    setFilter,
    hideIncomplete,
    setHideIncomplete,
}) => {
    const { tags, regions } = useFilters(filter?.term ?? '');
    const [leftFilters, setLeftFilter] = useState<FilterProps[]>([]);

    const updateHomepageFilter = (
        updatedOption: LeftFilterProps,
        filterId: string,
    ) => {
        setFilter((prevFilter) => {
            const updatedFilter = { ...prevFilter };
            // Get the array of filter values or initialize as empty array
            const filterValues = prevFilter[filterId] || [];
            if (!updatedOption.checked) {
                // Add the label to the array
                updatedFilter[filterId] = [
                    updatedOption.label,
                    ...filterValues,
                ];
            } else {
                updatedFilter[filterId] = filterValues.filter(
                    (value: string) => value !== updatedOption.label,
                ); // Remove the label from the array
            }
            // Reorder options array based on checked status
            const options = leftFilters.find(
                (filter) => filter.id === filterId,
            )?.options;
            if (options) {
                options.sort((a, b) =>
                    a.checked === b.checked ? 0 : a.checked ? -1 : 1,
                );
            }
            return updatedFilter;
        });
    };

    useEffect(() => {
        setLeftFilter([
            {
                id: 'tags',
                name: 'Tags',
                options: tags,
            },
            {
                id: 'regions',
                name: 'Regions',
                options: regions,
            },
        ]);
    }, [tags, regions]);

    return (
        <form>
            <h2 className="font-bold text-2xl text-true-blue mt-48  w-72	">
                Filter
            </h2>
            {setHideIncomplete !== undefined &&
                hideIncomplete !== undefined && (
                    <div className="mt-12 mb-8">
                        <b className="text-base text-true-blue">
                            Display options
                        </b>
                        <div className="flex justify-between items-center">
                            <p className="text-base text-true-blue">
                                Hide incomplete datasets
                            </p>
                            <NSwitch
                                hasIcon
                                modelValue={hideIncomplete}
                                onChange={() =>
                                    setHideIncomplete(!hideIncomplete)
                                }
                            />
                        </div>
                    </div>
                )}

            {leftFilters.map((section) => (
                <div key={section.id} className="mb-16">
                    <b className="text-base text-true-blue py-12">
                        {section.name}
                    </b>
                    {section.options.length > 7 && (
                        <AutocompleteCheckbox
                            items={section.options}
                            placeholder={'Search...'}
                            section={section.id}
                            setLeftFilter={setLeftFilter}
                            updateHomepageFilter={updateHomepageFilter}
                        />
                    )}
                    <CheckboxList
                        options={section.options}
                        section={section.id}
                        dropdown={false}
                        setLeftFilter={setLeftFilter}
                        updateHomepageFilter={updateHomepageFilter}
                    />
                </div>
            ))}
        </form>
    );
};
export default LeftFilters;
